import {
    HTTP_INTERCEPTORS,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withRouterConfig } from '@angular/router';
import { AuthHttpInterceptor, AuthModule } from '@auth0/auth0-angular';
import { APP_CONFIG, TenantInterceptor } from '@wdx/kamino/api-service';
import { IMeLocale, WINDOW_PROVIDERS } from '@wdx/shared/utils';
import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { ToastrInterceptor } from './app/shared/interceptors/toastr/toastr.interceptor';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { reducers } from '@wdx/kamino/state';
import { environment } from './environments/environment';
import { of } from 'rxjs';

fetch('/assets/config.json')
    .then((res) => res.json())
    .then((config) => {
        if (environment.production) {
            enableProdMode();
        }
        bootstrapApplication(AppComponent, {
            providers: [
                provideZoneChangeDetection(),provideRouter(
                    appRoutes,
                    withRouterConfig({ paramsInheritanceStrategy: 'always' }),
                ),
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: AuthHttpInterceptor,
                    multi: true,
                },
                { provide: APP_CONFIG, useValue: config },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: TenantInterceptor,
                    multi: true,
                },
                {
                    provide: HTTP_INTERCEPTORS,
                    useClass: ToastrInterceptor,
                    multi: true,
                },
                {
                    provide: IMeLocale,
                    useValue: {
                        getMeLocale: () => undefined,
                        getMeLocale$: () => of(undefined),
                    },
                },

                importProvidersFrom(
                    StoreModule.forRoot(reducers),
                    StoreDevtoolsModule.instrument({
                        maxAge: 500,
                        logOnly: environment.production,
                        connectInZone: true,
                    }),

                    AuthModule.forRoot({
                        domain: config.authDomain,
                        clientId: config.clientId,
                        authorizationParams: {
                            audience: config.audience,
                            scope: 'access:user',
                            redirect_uri: window.location.origin,
                        },
                        useRefreshTokens: true,
                        errorPath: '/error',
                        httpInterceptor: {
                            allowedList: [
                                {
                                    uri: `${config.apiDomain}/*`,
                                    tokenOptions: {
                                        authorizationParams: {
                                            audience: config.audience,
                                            scope: 'access:user',
                                        },
                                    },
                                },
                            ],
                        },
                    }),
                ),
                provideHttpClient(withInterceptorsFromDi()),
                WINDOW_PROVIDERS,
            ],
        }).catch((err) => console.error(err));
    });
